import { getImageUrl } from '../../../utils/helpers'
import type { UnifiedGalleryItem } from '../Gallery'

interface GalleryItemProps {
  item: UnifiedGalleryItem
  onClick: () => void
}

function GalleryItem({ item, onClick }: GalleryItemProps) {
  // Get the appropriate thumbnail URL
  const thumbnailUrl = item.type === 'youtube'
    ? item.thumbnail_url
    : item.file_path
      ? getImageUrl(item.file_path)
      : item.thumbnail_url

  return (
    <article className="gallery-item" onClick={onClick}>
      <div className="gallery-item-media">
        {item.type === 'youtube' ? (
          // YouTube video - show thumbnail with YouTube play icon
          <>
            <img src={thumbnailUrl} alt={item.title} loading="lazy" />
            <div className="video-indicator youtube-indicator">
              <svg viewBox="0 0 68 48" className="youtube-icon">
                <path
                  d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
                  fill="#FF0000"
                />
                <path d="M 45,24 27,14 27,34" fill="#fff" />
              </svg>
            </div>
          </>
        ) : item.is_video ? (
          // Uploaded video - show video element with play indicator
          <>
            <video src={thumbnailUrl} muted playsInline />
            <div className="video-indicator">▶</div>
          </>
        ) : (
          // Image
          <img src={thumbnailUrl} alt={item.title} loading="lazy" />
        )}
      </div>
      <div className="gallery-item-info">
        <h3>{item.title}</h3>
        {item.category_name && <p className="category">{item.category_name}</p>}
      </div>
    </article>
  )
}

export default GalleryItem
